import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcMaintenanceTypesInputComponent } from './fc-maintenance-types-input.component';


@NgModule({
  declarations: [
    FcMaintenanceTypesInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcMaintenanceTypesInputComponent
  ]
})
export class FcMaintenanceTypesInputModule {}
